module.exports = __webpack_public_path__ + "media/images/marinade-19380f45.png";